export default __webpack_public_path__ + "static/media/Download.1599e838.svg";